import axios from 'axios';
import favoriteResultTemplate from '@/components/toasts/templates/favorite-toast.twig';
import {IFavoriteApi} from '@/common/scripts/types/favorites';
import type {IResponse} from '@/common/scripts/types/utils';

interface IFavoriteToastData {
    state: boolean;
    title: string;
    text: string;
    link: string | null;
}

interface IFavoriteResponseData {
    quantity: number;
}

type IFavoriteResponse = IResponse<IFavoriteResponseData>;

const CLASS_HEADER_ACTIVE = 'is-active';
const CLASS_TOAST_NONE_HIDDEN = 'is-hidden';
const toastContainer = document.querySelector<HTMLElement>('.j-toasts');

const showFavoriteToast = (toastData: IFavoriteToastData): void => {
    const favoriteToast = favoriteResultTemplate({toastData});

    const wrapper = document.createElement('div');

    wrapper.innerHTML = favoriteToast;
    const node = wrapper.firstElementChild;

    if (node && toastContainer) {
        toastContainer.appendChild(node);

        const closeBtn = node.querySelector('.j-favorite-toast-close-btn');

        if (closeBtn) {
            closeBtn.addEventListener('click', () => {
                removeFavoriteToast(node);
            });
        }

        // Небольшая задержка, чтобы браузер успел отрисовать начальное состояние
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                node.classList.remove(CLASS_TOAST_NONE_HIDDEN);
            });
        });

        // Автоматическое удаление через 1.5c
        setTimeout(() => {
            removeFavoriteToast(node);
        }, 1500);
    }
};

const removeFavoriteToast = (node: Node): void => {
    if (!node) {
        return;
    }

    if (node instanceof HTMLElement) {
        node.classList.add(CLASS_TOAST_NONE_HIDDEN);

        setTimeout(() => {
            node.remove();
        }, 400);
    }
};

const getToastText = (favoriteButton: HTMLElement): {title: string, text: string} => {
    const text = favoriteButton.dataset['state'] === 'true' ? 'удалено из избранного' : 'добавлено в избранное';
    const name = favoriteButton.dataset['title'] || 'Помещение';
    const area = favoriteButton.dataset['area'] || null;
    const title = [name, area].filter(Boolean).join(', ');

    return {
        title,
        text
    };
};

export const useAddToFavoriteButton = (favoriteButton: HTMLElement): void => {
    if (!favoriteButton) {
        return;
    }

    const headerFavorites = document.querySelectorAll('.j-favorite');

    favoriteButton.addEventListener('click', () => {
        const state = favoriteButton.dataset['state'] === 'true';
        const premisesID = favoriteButton.dataset['id'] || null;
        const toastData = getToastText(favoriteButton);
        const premiseData = {
            state,
            title: toastData.title,
            text : toastData.text,
            link : favoriteButton.dataset['link'] || null
        };

        const url = state ? IFavoriteApi.remove : IFavoriteApi.add;
        // const url = state ? '/tests/favorites/favorite-remove.php' : '/tests/favorites/favorite-add.php';

        axios.post(url, {id: premisesID})
            .then((res: IFavoriteResponse) => {
                favoriteButton.dataset['state'] = String(!state);

                if (res.data.data.quantity > 0) {
                    headerFavorites.forEach((element: Element) => {
                        element.classList.add(CLASS_HEADER_ACTIVE);
                    });
                } else {
                    headerFavorites.forEach((element: Element) => {
                        element.classList.remove(CLASS_HEADER_ACTIVE);
                    });
                }
            })
            .catch(() => {
                console.error('Error occurred while updating favorite status');
            })
            .then(() => {
                if (toastContainer) {
                    showFavoriteToast(premiseData);
                }
            });
    });
};
